import type { CatalogRatioShortData, CatalogRatioData } from '@gql/graphql';
import { RatioTypeEnum } from '@gql/graphql';

import { Checkbox } from '@consta/uikit/Checkbox';
import { useEffect, useMemo, useState } from 'react';

import Styles from '../../addRatiosModal.module.css';

interface UpdateBaseCostRatioRowData extends CatalogRatioData {
    groupRow?: boolean;
}

interface ICoefficientRenderCheckbox {
    checkedIds: Record<string, CatalogRatioShortData | null>;
    activeTabId: RatioTypeEnum;
    data: UpdateBaseCostRatioRowData;
    handleChangeCheckbox: (row: CatalogRatioData) => ({ checked }: { checked: boolean }) => void;
    handleAllChangeCheckbox: (data: Record<string, boolean>) => () => void;
    currentRowData: CatalogRatioData[] | null;
    isHeadCheckbox: boolean;
    canCheckGroupRow: boolean;
    canCheckRow: boolean;
}

export const CellRenderCheckbox = (props: ICoefficientRenderCheckbox) => {
    const {
        checkedIds,
        activeTabId,
        data,
        handleChangeCheckbox,
        handleAllChangeCheckbox,
        currentRowData,
        isHeadCheckbox,
        canCheckGroupRow,
        canCheckRow,
    } = props;

    const [checkedAll, setCheckedAll] = useState<boolean>(false);

    const trueValuesByGroupLength = useMemo(
        () =>
            Object.values(checkedIds).filter(
                (value) => !!value && currentRowData?.some((ratio) => ratio.id === value.id),
            ).length,
        [checkedIds, currentRowData],
    );

    useEffect(() => {
        setCheckedAll(currentRowData?.length === trueValuesByGroupLength);
    }, [currentRowData?.length, trueValuesByGroupLength]);

    const intermediate = trueValuesByGroupLength > 0 && trueValuesByGroupLength !== currentRowData?.length;

    const currentAllCheckId = currentRowData?.reduce((acc: { [x: string]: boolean }, curr: { id: string | number }) => {
        acc[curr.id] = true;

        return acc;
    }, {});

    const dataAllChange = useMemo(() => {
        if (checkedAll) {
            return {};
        }

        return currentAllCheckId || {};
    }, [checkedAll, currentAllCheckId]);

    if (isHeadCheckbox && activeTabId !== RatioTypeEnum.TechPartCoef) {
        return null;
    }

    const headRows = isHeadCheckbox || data?.groupRow;
    const currentChecked = headRows ? checkedAll : !!checkedIds[data?.id];
    const currentChange = headRows ? handleAllChangeCheckbox(dataAllChange) : handleChangeCheckbox(data);
    const currentIntermediate = headRows ? intermediate : false;

    const currentDisabled = (() => {
        if (isHeadCheckbox) {
            return currentRowData?.length === 0;
        }

        return headRows ? !canCheckGroupRow : !canCheckRow;
    })();

    return (
        <div className="CheckboxWrapper">
            <Checkbox
                className={Styles.checkboxFocus}
                checked={currentChecked}
                onChange={currentChange}
                disabled={currentDisabled}
                intermediate={currentIntermediate}
            />
        </div>
    );
};

CellRenderCheckbox.displayName = 'CellRenderCheckbox';
